'use strict';

import { CoreRepository } from '../CoreRepository';
import { UserFlowStage } from '../../Entities/User/UserFlowStage';
import { UserFlowStageCollection } from '../../Collections/User/UserFlowStageCollection';
import { IndCollection } from '../../Collections/Ind/IndCollection';
import { Ind } from '../../Entities/Ind/Ind';
import { IndFlowAssignment } from '../../Entities/Ind/IndFlowAssignment';
import { IndFlowAssignmentCollection } from '../../Collections/Ind/IndFlowAssignmentCollection';

export class UserFlowStageRepository extends CoreRepository {
  public getUserFlowStages(flowId: number, options: object = {}, criteria: object = null) {
    if (!options) {
      options = {};
    }

    if (criteria) {
      options['criteria'] = criteria;
    }

    return this.webAPI.getUserFlowStages(flowId, options).then((response) => {
      const collection = new UserFlowStageCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new UserFlowStage();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }

  public getUserFlowStageInds(
    flowId: number,
    flowStageId: number,
    options: object = {},
    criteria: object = null
  ) {
    if (!options) {
      options = {};
    }

    if (criteria) {
      options['criteria'] = criteria;
    }

    return this.webAPI.getUserFlowStageInds(flowId, flowStageId, options).then((response) => {
      const collection = new IndFlowAssignmentCollection();
      response.data.forEach((collectionItemData) => {
        const collectionItem = new IndFlowAssignment();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }

  public getUserFlowStage(flowId: number, flowStageId: number, options: object = null) {
    if (!options) {
      options = {};
    }

    return this.webAPI.getUserFlowStage(flowId, flowStageId, options).then((response) => {
      if (!response) {
        return false;
      }

      const userFlowStage = new UserFlowStage();
      userFlowStage.hydrate(response);

      return userFlowStage;
    });
  }

  public createUserFlowStage(flowId: number, payload: object = {}) {
    return this.webAPI.addUserFlowStage(flowId, payload).then((response) => {
      const userFlowStage = new UserFlowStage();
      userFlowStage.hydrate(response);

      return userFlowStage;
    });
  }

  public updateUserFlowStage(flowId: number, flowStageId: number, payload: object = {}) {
    return this.webAPI.updateUserFlowStage(flowId, flowStageId, payload).then((response) => {
      const userFlowStage = new UserFlowStage();
      userFlowStage.hydrate(response);

      return userFlowStage;
    });
  }

  public updateUserFlowStageSortOrders(flowId: number, payload) {
    return this.webAPI.updateUserFlowStageSortOrder(flowId, payload).then((response) => {
      const userFlowStage = new UserFlowStage();
      userFlowStage.hydrate(response);

      return userFlowStage;
    });
  }

  public removeUserFlowStage(flowId: number, flowStageId: number) {
    return this.webAPI.removeUserFlowStage(flowId, flowStageId).then((response) => {
      return response;
    });
  }

  public updateUserFlowStageSortOrder(flowId: number, payload) {
    return this.webAPI.updateUserFlowStageSortOrder(flowId).then((response) => {
      return response;
    });
  }
}
